import { provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { loadRuntimeConfig } from './runtime-config';

/**
 * APP_INITIALIZER que carrega /assets/config.json antes do app iniciar.
 * Memoizado: se main.ts ja disparou o carregamento (para configurar o Amplify),
 * reaproveita o mesmo resultado.
 */
export function provideAppConfigInitializer(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    await loadRuntimeConfig();
  });
}
